import { useContext, type Context } from 'react';
import { useSyncExternalStoreWithSelector } from 'use-sync-external-store/shim/with-selector';

import type { Store } from './store.js';

/**
 * A hook that allows you to subscribe to state updates from the store.
 * @public
 */
export function useStoreSelector<T, S>(
  context: Context<Store<S>>,
  selector: (state: S) => T,
  isEqual?: (a: T, b: T) => boolean,
) {
  const store = useContext(context);
  return useSyncExternalStoreWithSelector<S, T>(
    store.subscribe,
    () => store.getState(),
    null,
    selector,
    isEqual,
  );
}
